import { LuChevronDown } from 'react-icons/lu';

import { Button } from '../../../components/ui/button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';
import { EventCalendarView, useEventCalendarViewState } from '../calendar-state';

export const EventCalendarActionMenu = () => {
    const { eventCalendarViewState, setEventCalendarViewState } = useEventCalendarViewState();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline2" size="sm" className="px-3">
                    {eventCalendarViewState.calendarView === EventCalendarView.DAY_GRID_MONTH && 'Month'}
                    {eventCalendarViewState.calendarView === EventCalendarView.TIME_GRID_WEEK && 'Week'}
                    {eventCalendarViewState.calendarView === EventCalendarView.TIME_GRID_DAY && 'Day'}
                    <LuChevronDown className="text-cocoa-500 h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <DropdownMenuCheckboxItem
                    checked={eventCalendarViewState.calendarView === EventCalendarView.DAY_GRID_MONTH}
                    onSelect={() => setEventCalendarViewState({ calendarView: EventCalendarView.DAY_GRID_MONTH })}
                >
                    Month
                </DropdownMenuCheckboxItem>
                <DropdownMenuCheckboxItem
                    checked={eventCalendarViewState.calendarView === EventCalendarView.TIME_GRID_WEEK}
                    onSelect={() => setEventCalendarViewState({ calendarView: EventCalendarView.TIME_GRID_WEEK })}
                >
                    Week
                </DropdownMenuCheckboxItem>
                <DropdownMenuCheckboxItem
                    checked={eventCalendarViewState.calendarView === EventCalendarView.TIME_GRID_DAY}
                    onSelect={() => setEventCalendarViewState({ calendarView: EventCalendarView.TIME_GRID_DAY })}
                >
                    Day
                </DropdownMenuCheckboxItem>
                <DropdownMenuSeparator />
                <DropdownMenuCheckboxItem
                    checked={eventCalendarViewState.showWeekends}
                    onSelect={() => setEventCalendarViewState({ showWeekends: !eventCalendarViewState.showWeekends })}
                >
                    Show Weekends
                </DropdownMenuCheckboxItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
